module.exports = __webpack_public_path__ + "img/alerta.bf1fdb95.svg";